import '../../../../../motion-utils/dist/es/errors.mjs';
import { memo } from '../../../../../motion-utils/dist/es/memo.mjs';
var supportsScrollTimeline = memo(function () {
  return window.ScrollTimeline !== undefined;
});
export { supportsScrollTimeline };